/* popup-pincode-phone.js  auto-generated from popup-pincode-phone.liquid.
   Asset-cached; merchant settings flow in via data-* attributes on the section root
   plus CSS custom properties for colors/layout. Only the small inline style block
   re-renders on setting changes. */
(function(){
  if (window.__sleepyhead_popup_pp_booted) return;
  window.__sleepyhead_popup_pp_booted = true;
  function initPopup(root){
    var sectionId = root.id.replace(/^popup-pp-/, '');
if(!window.SleepyheadPopup)return;var D = window.SleepyheadPopup;
  var cfg = root.dataset;
  var popupId = cfg.popupId;
  var API = {
    pincodeCheck: 'https://pos.mysleepyhead.com/index.php/api/pincodechecker_new',
    nitroLog: 'https://dfxstorelocatorapi.azurewebsites.net/api/PinCodeETA/PinCodeDetails',
    nitroAuth: 'Basic REZYLlBpbmNvZGUuVXNlcjpEdXJvZmxleEAxMjMj',
    sendOtp: 'https://dfxstorelocatorapi.azurewebsites.net/api/Trustsignal/SendOtp',
    verifyOtp: 'https://dfxstorelocatorapi.azurewebsites.net/api/Trustsignal/VerifyOtp',
    googleLeadCapture: 'https://script.google.com/macros/s/AKfycbyboGLhUYexzHjQmqtaAcxBK5Ta88bQynUi0MDV4PtYGwmtiuTvCrY_KGLsKgpexZPg/exec',
    salesforceLeadCapture: 'https://dfxstorelocatorapi.azurewebsites.net/api/SleepQuiz/LeadCreation',
    salesforceLeadKey: 'TGVhZENyZWF0aW9uU2xlZXBxdWl6'
  };
  var SUBMIT_LEAD_PRE_OTP = true;

  // Register manual-open listener FIRST so chip/legacy buttons can force-reopen
  // even when auto-open is blocked by skip_if_pincode_set / dismiss / frequency cap.
  // `tryOpen` is hoisted (function declaration further down in this scope).
  window.addEventListener('sleepyhead:open-pincode-popup', function(e){
    tryOpen(e && e.detail && e.detail.force);
  });

  // Debug mode
  if (new URLSearchParams(location.search).has('popup_debug')) { D._debug = true; }

  // Device gating
  var isMobile = window.matchMedia('(max-width: 767px)').matches;
  if (cfg.device === 'mobile' && !isMobile) return;
  if (cfg.device === 'desktop' && isMobile) return;

  // Scope (page type + handle) gating
  if (!checkScope()) return;

  // skipAutoOpen flag pattern: any condition that should block AUTO-open but
  // STILL allow manual reopen via chip/legacy buttons sets this flag instead of
  // hard-returning. Init proceeds to declare form vars + bind close listener so
  // tryOpen(force=true) from the chip can re-render a fresh form state.
  var skipAutoOpen = false;

  // skip_if_pincode_set blocks auto-open only; chip can still force-reopen.
  if (cfg.skipIfPincodeSet === 'true' && D.getPincode()) skipAutoOpen = true;

  // Pincode rule gating (but this popup COLLECTS pincode, so its own pincode rule is usually 'off')
  var pincodeRule = {
    mode: cfg.pincodeMode || 'off',
    list: D.parseList(cfg.pincodeList),
    prefixes: D.parseList(cfg.pincodePrefixes),
    fallback: cfg.pincodeFallback || 'show'
  };
  var pincodeMatch = D.matchesPincodeRule(pincodeRule);
  if (pincodeMatch === false) skipAutoOpen = true;
  if (pincodeMatch === null) {
    D.onPincodeSet(function(){ if (!skipAutoOpen) tryOpen(); });
  }

  // Frequency capping
  var freq = D.passesFrequency(popupId, {
    maxSession:  parseInt(cfg.maxSession, 10) || 0,
    maxLifetime: parseInt(cfg.maxLifetime, 10) || 0,
    minPageviews: parseInt(cfg.minPageviews, 10) || 0,
    mode: cfg.visitorType
  });
  if (!freq.ok) { track('skipped', { reason: freq.reason }); skipAutoOpen = true; }

  // Singleton guard with specificity: handle match > specific page-type > exclude > scope=all
  var __specificity = D.computePopupSpecificity(cfg, cfg.currentHandle);
  if (!D.claimSingleton('popup-pincode-phone', popupId, __specificity)) {
    track('skipped', { reason: 'outranked_by_specificity', active_instance: D.singletonOwner('popup-pincode-phone'), my_specificity: __specificity, winner_specificity: D.singletonSpecificity('popup-pincode-phone') });
    skipAutoOpen = true;
  }

  // Dismiss gating — blocks auto-open. Chip reopen with force=true bypasses inside tryOpen.
  if (D.isDismissed(popupId) || D.isSessionDismissed(popupId)) skipAutoOpen = true;

  // Prefill if we already know
  var existingPincode = D.getPincode();
  var existingPhone = D.getPhone();

  // ----- Open/close -----
  var opened = false;
  function tryOpen(force){
    // Force flag bypasses all guards — used when user explicitly clicks Change
    if (force) {
      opened = false;
      D.resetDismiss(popupId);
      // Reset the popup to the fresh form state (clears done/success UI from a prior run)
      setState('form');
    }
    if (opened) return;
    // Re-verify singleton ownership — a higher-specificity instance may have dethroned us
    if (!force && D.singletonOwner('popup-pincode-phone') !== popupId) {
      track('skipped', { reason: 'dethroned_pre_show', active_instance: D.singletonOwner('popup-pincode-phone') });
      return;
    }
    if (!force && (D.isDismissed(popupId) || D.isSessionDismissed(popupId))) return;
    if (!force && cfg.skipIfPincodeSet === 'true' && D.getPincode()) return;
    opened = true;
    root.removeAttribute('hidden');
    // Apply class changes synchronously — RAF was not firing reliably in some contexts
    root.classList.remove('popup-pp--hidden');
    root.classList.add('popup-pp--visible');
    document.body.classList.add('popup-pp-open');
    if (window.SleepyheadPopup && window.SleepyheadPopup._debug) console.log('[popup-pp] opened; classes now:', root.className);
    var c = D.incImpression(popupId);
    track('open', { session_impressions: c.session, lifetime_impressions: c.lifetime, returning_user: freq.returning });
    trackQlp('qlp_pincode_popup_viewed', { session_impressions: c.session, lifetime_impressions: c.lifetime, returning_user: freq.returning, forced: !!force });
    var firstInput = root.querySelector('[data-field="phone"] input');
    if (firstInput && !existingPincode) firstInput.focus();
  }
  function close(){
    root.classList.remove('popup-pp--visible');
    root.classList.add('popup-pp--hidden');
    document.body.classList.remove('popup-pp-open');
    opened = false;  // allow re-open via chip / manual event
    // Spec: pincode submit success → 30d localStorage dismiss
    //       pincode abandon (no successful submit) → session-only, reshow next session
    var completed = D.isFormCompleted(popupId);
    var persisted = D.closeWithRules({
      popupId: popupId,
      persistMode: completed ? 'days' : 'session',
      persistDays: 30,
      requireFormStarted: false,
      requireFormCompleted: false
    });
    track('close', { persisted: persisted, state: state, form_started: D.isFormStarted(popupId), form_completed: completed, dismiss_kind: completed ? 'days_30' : 'session' });
    trackQlp('qlp_popup_closed', { state: state, form_completed: completed, dismiss_kind: completed ? 'days_30' : 'session' });
    // qlp_otp_abandoned: OTP was sent but never verified before close.
    if (otpSent && !phoneVerified && !completed) {
      trackQlp('qlp_otp_abandoned', { phone_hash: D.getPhone() ? String(D.getPhone()).slice(0,2)+'****'+String(D.getPhone()).slice(-2) : '' });
    }
    D.afterClose({
      popupId: popupId,
      // Suppress merchant close_behavior on abandon to avoid surprise redirects.
      closeBehavior: completed ? cfg.closeBehavior : 'none',
      teaserText: cfg.closeTeaserText,
      offerBarText: cfg.closeOfferText,
      pillLabel: cfg.closePillText,
      redirectUrl: cfg.closeRedirectUrl,
      closeEventUrl: cfg.closeEventUrl,
      closeMetaEvent: cfg.closeMetaEvent,
      closeGtagConversion: cfg.closeGtagConversion,
      closeJourneyUrl: cfg.closeJourneyUrl
    }, { state: state, pincode: D.getPincode(), phone: D.getPhone() }, function reopen(){ opened = false; tryOpen(); });
  }

  // Re-engagement triggers (fire after dismiss)
  D.setupReopen({
    popupId: popupId,
    reopenAfterMinutes: cfg.reopenAfterMinutes,
    reopenOnExitIntent: cfg.reopenOnExitIntent === 'true',
    reopenOnScrollPct: cfg.reopenOnScrollPct,
    resetOnCartAdd: cfg.resetOnCartAdd === 'true'
  }, function(){ opened = false; tryOpen(); });

  // Mark form as started on any input (fields queried here since var declarations happen later)
  root.querySelectorAll('.popup-pp__field input').forEach(function(inp){
    inp.addEventListener('input', function(){ D.markFormStarted(popupId); }, { once: true });
  });

  function track(name, params){
    if (cfg.trackEvents !== 'true') return;
    D.track((cfg.eventPrefix || 'pp') + '_' + name, Object.assign({ popup_id: popupId }, params || {}));
  }
  // qlp_* event taxonomy: emitted in parallel to the prefixed sleepyhead_* events
  // so GA4/GTM can register either / both. Names match the exact strings the
  // analytics team requested — no prefix concat, sent as-is.
  function trackQlp(name, params){
    if (cfg.trackEvents !== 'true') return;
    D.track(name, Object.assign({ popup_id: popupId }, params || {}));
  }

  // ----- Trigger -----
  // Auto-open trigger only when skipAutoOpen flags allow it. Manual reopen via
  // window 'sleepyhead:open-pincode-popup' (chip/legacy) bypasses this entirely.
  if (!skipAutoOpen) {
    var trigger = cfg.trigger || 'delay';
    if (trigger === 'delay') {
      var ms = Math.max(0, (parseFloat(cfg.autoOpenDelay) || 0) * 1000);
      setTimeout(tryOpen, ms);
    } else if (trigger === 'exit_intent') {
      document.addEventListener('mouseleave', function onLeave(e){
        if (e.clientY <= 0 || e.relatedTarget === null) {
          document.removeEventListener('mouseleave', onLeave);
          tryOpen();
        }
      });
    } else if (trigger === 'scroll') {
      var pct = Math.max(1, parseInt(cfg.scrollPct, 10) || 40) / 100;
      var onScroll = function(){
        var scrolled = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
        if (scrolled >= pct) { window.removeEventListener('scroll', onScroll); tryOpen(); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    // 'manual' trigger = no auto-open binding here either; rely on chip dispatch.
  }
  // Listener for 'sleepyhead:open-pincode-popup' was registered at the top of
  // initPopup so chip/legacy buttons always work even when auto-open is skipped.

  // Close button + backdrop + ESC
  root.querySelector('.popup-pp__close').addEventListener('click', close);
  if (cfg.closeOnBackdrop === 'true') {
    root.querySelector('.popup-pp__backdrop').addEventListener('click', close);
  }
  if (cfg.closeOnEscape === 'true') {
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && root.classList.contains('popup-pp--visible')) close();
    });
  }

  // ----- Form wiring -----
  var form = root.querySelector('.popup-pp__form');
  var pinField = root.querySelector('[data-field="pincode"]');
  var phField  = root.querySelector('[data-field="phone"]');
  var otpField = root.querySelector('[data-field="otp"]');
  var successBox = root.querySelector('.popup-pp__success');
  var cta = root.querySelector('.popup-pp__cta');
  var pinInput = pinField.querySelector('input');
  var phInput  = phField.querySelector('input');
  var otpInput = otpField.querySelector('input');
  // Status nodes. The pincode field carries the shared status line. OTP errors
  // (e.g. "Invalid OTP", "Could not send OTP") now render inline in the OTP meta
  // row (.popup-pp__status--otp, beside the Resend OTP link). Phone errors fall
  // back to the pincode status. Progress chatter ("Verifying…"/"Verified") is removed.
  var pinStatus = pinField.querySelector('.popup-pp__status--pincode') || pinField.querySelector('.popup-pp__status');
  var phStatus  = phField.querySelector('.popup-pp__status--phone') || pinStatus;
  var otpStatus = root.querySelector('.popup-pp__status--otp') || pinStatus;


  // Single-screen flow controls
  var verifyBtn    = root.querySelector('.popup-pp__verify-btn');     // inline "Verify" (send OTP)
  var verifyOtpBtn = root.querySelector('.popup-pp__verify-otp-btn'); // explicit "Verify OTP" (calls verify API)
  var otpGroup     = root.querySelector('[data-role="otp-group"]') || root.querySelector('.popup-pp__otp-group'); // inseparable OTP input + Verify OTP
  var otpWrap      = root.querySelector('.popup-pp__otp-wrap');        // inline OTP input slot
  var otpMeta      = root.querySelector('[data-role="otp-meta"]');     // resend row (below the zone)

  var phoneCheck  = root.querySelector('[data-role="phone-check"]');  // red tick beside phone
  var otpCheck    = root.querySelector('[data-role="otp-check"]');    // red tick beside otp
  var geoBtn      = root.querySelector('[data-action="fetch-location"]');

  // phoneVerified: gates the bottom CTA. Keyed to the verified phone number only —
  // changing pincode does NOT reset it; changing phone DOES.
  var phoneVerified = false;
  var verifiedPhone = '';
  var otpSent = false;


  // digit-only enforcement
  [pinInput, phInput, otpInput].forEach(function(inp){
    if (!inp) return;
    inp.addEventListener('input', function(){ inp.value = inp.value.replace(/\D/g, ''); });
  });

  // Prefill pincode if known
  if (existingPincode) pinInput.value = existingPincode;
  if (existingPhone)   phInput.value  = existingPhone;

  // SS4: if the prefilled phone was already OTP-verified in this browser (stored
  // via shared utils), restore the verified state so the user does NOT have to
  // re-verify when they reopen the popup (e.g. clicked "Change pincode or phone").
  function applyPersistedVerification(){
    var ph = (phInput.value || '').trim();
    if (!ph) return false;
    if (D.isPhoneVerified && D.isPhoneVerified(ph)) {
      phoneVerified = true;
      verifiedPhone = ph;
      otpSent = false;
      // Collapse the OTP affordances — no input/verify/resend needed.
      if (otpGroup) otpGroup.hidden = true;
      if (otpWrap) otpWrap.hidden = true;
      if (otpMeta) otpMeta.hidden = true;
      if (verifyBtn) verifyBtn.hidden = true;
      if (verifyOtpBtn) { verifyOtpBtn.hidden = true; verifyOtpBtn.disabled = true; }
      // Show the verified tick + lock the phone (editing it resets verification).
      if (phoneCheck) phoneCheck.hidden = false;
      if (phField) { var pw = phField.querySelector('.popup-pp__phone-wrap'); if (pw) pw.classList.add('is-verified'); }
      if (phInput) phInput.readOnly = true;
      // Phone is verified → the bottom CTA is immediately usable.
      setCtaEnabled(true);
      return true;
    }
    return false;
  }


  // State machine — merged form (pincode + phone) -> otp -> done
  var state = 'form';
  var pincodeResult = null; // stores { serviceable, city, estimated_delivery_date, pincode, ... }
  var summaryBox = root.querySelector('[data-role="summary"]');
  var submitInFlight = false;
  var leadSubmitInFlight = {};
  var leadSubmitted = {};
  function setState(s){
    state = s;
    form.dataset.step = s;
    // Single-screen flow: pincode + phone always visible. OTP appears inline.
    if (s === 'form') {
      pinField.hidden = false;
      phField.hidden  = false;
      otpField.hidden = false; // container; inner otpWrap visibility is managed separately
      if (pinInput) pinInput.readOnly = false;
      if (phInput)  phInput.readOnly = false;
      // Reset success / delivery / coupon state so re-opens from done/chip start clean
      if (successBox) successBox.hidden = true;
      root.querySelectorAll('.popup-pp__delivery').forEach(function(el){ el.hidden = true; });
      var coup = root.querySelector('.popup-pp__coupon');
      if (coup) coup.hidden = true;
      cta.hidden = false;
      // Clear any prior status messages
      [pinStatus, phStatus, otpStatus].forEach(function(el){ if (el) { el.textContent = ''; el.className = el.className.replace(/ popup-pp__status--(ok|err|info)/g, ''); } });
      // Reset the inline OTP/verify UI to its initial collapsed state
      resetVerification();
      // SS4: if the (prefilled) phone was already OTP-verified within the last 24h,
      // restore the verified state so the user skips OTP on reopen / change.
      applyPersistedVerification();

    } else if (s === 'done') {
      form.querySelectorAll('.popup-pp__field').forEach(function(f){
        if (f.closest('[data-role="details"]')) return;
        f.hidden = true;
      });
      cta.hidden = true;
      successBox.hidden = false;
      renderDeliveryStatus();
    }
    Array.prototype.forEach.call(cta.querySelectorAll('.popup-pp__cta-label'), function(el){
      el.hidden = el.dataset.state !== s;
    });
  }

  // ----- Single-screen verification helpers -----
  // The bottom CTA stays disabled until the phone is OTP-verified. Pincode is
  // validated only when the (now enabled) CTA is clicked. Phone-only keying:
  // editing the phone resets verification; editing the pincode does NOT.
  function syncVerifyBtn(){
    if (!verifyBtn) return;
    var phone = (phInput.value || '').trim();
    var valid = /^[6-9]\d{9}$/.test(phone);
    // Hide Verify entirely once verified; otherwise show it whenever OTP not yet sent.
    if (phoneVerified) { verifyBtn.hidden = true; return; }
    verifyBtn.hidden = otpSent; // hide while OTP slot is showing
    verifyBtn.disabled = !valid;
  }

  function setCtaEnabled(on){
    cta.disabled = !on;
    cta.classList.toggle('is-verified', !!on);
  }

  // Reset the inline OTP UI + verified state. Called on form (re)entry and on phone edits.
  function resetVerification(){
    phoneVerified = false;
    verifiedPhone = '';
    otpSent = false;
    if (otpGroup) otpGroup.hidden = true;
    if (otpWrap) otpWrap.hidden = true;
    if (otpMeta) otpMeta.hidden = true;
    if (otpCheck) otpCheck.hidden = true;
    if (phoneCheck) phoneCheck.hidden = true;
    if (otpWrap) otpWrap.classList.remove('is-verified');
    if (phField) { var pw = phField.querySelector('.popup-pp__phone-wrap'); if (pw) pw.classList.remove('is-verified'); }
    if (otpInput) { otpInput.value = ''; otpInput.disabled = false; }
    if (verifyBtn) verifyBtn.hidden = false;
    if (verifyOtpBtn) { verifyOtpBtn.hidden = true; verifyOtpBtn.disabled = true; }
    setCtaEnabled(false);
    syncVerifyBtn();
  }

  // Show/enable the explicit "Verify OTP" button only when the OTP reaches the
  // required length. NO API is called here — the user must click to verify.
  function syncVerifyOtpBtn(){
    if (!verifyOtpBtn) return;
    if (phoneVerified || !otpSent) { verifyOtpBtn.hidden = true; verifyOtpBtn.disabled = true; return; }
    var otp = (otpInput && otpInput.value || '').trim();
    var ready = /^\d{6}$/.test(otp);
    verifyOtpBtn.hidden = !ready;
    verifyOtpBtn.disabled = !ready;
  }



  function renderDeliveryStatus(){
    var ok  = root.querySelector('.popup-pp__delivery--ok');
    var no  = root.querySelector('.popup-pp__delivery--no');
    if (!ok || !no) return;
    var result = pincodeResult || D.getPincodeData() || {};
    var pin = D.getPincode();
    function fill(el, tpl){
      var msg = el.querySelector('.popup-pp__delivery-msg');
      if (!msg) return;
      var txt = msg.textContent || '';
      // Support both [placeholder] and {placeholder} syntaxes for backward compatibility
      txt = txt.replace(/[\[\{]city[\]\}]/g,    result.city || '')
               .replace(/[\[\{]eta[\]\}]/g,     result.estimated_delivery_date || '')
               .replace(/[\[\{]pincode[\]\}]/g, pin || '');
      msg.textContent = txt;
    }
    if (result.serviceable) {
      fill(ok);
      ok.hidden = false;
    } else {
      fill(no);
      no.hidden = false;
    }
  }

  function setStatus(el, msg, kind){
    el.textContent = msg || '';
    el.className = 'popup-pp__status popup-pp__status--' + (el.classList.contains('popup-pp__status--pincode') ? 'pincode' : el.classList.contains('popup-pp__status--phone') ? 'phone' : 'otp');
    if (kind) el.classList.add('popup-pp__status--' + kind);
  }

  // ----- Pincode check (always continue to OTP regardless of serviceability) -----
  function validatePincode(pin){
    pin = String(pin || '').trim();
    if (!/^\d{6}$/.test(pin)) { setStatus(pinStatus, 'Enter a valid 6-digit pincode', 'err'); return Promise.resolve(false); }
    setStatus(pinStatus, 'Checking delivery...', 'info');
    // On product pages, reuse the current product's group from the DOM (matches main-product.liquid).
    // Fall back to the configured default_product_group (default: ALL).
    var domGroup = (document.querySelector('#variant_block_product_group_l')?.textContent || '').trim();
    var domL5    = (document.querySelector('#variant_block_product_group_l5')?.textContent || '').trim();
    var domL6    = (document.querySelector('#variant_block_product_group_l6')?.textContent || '').trim();
    var domSku   = (document.querySelector('#selected_variant_sku')?.textContent || '').trim();
    var body = {
      l1_product_group: domGroup || cfg.productGroup || 'ALL',
      l5_product_group: domL5,
      l6_product_group: domL6,
      pincode: pin, qty: 1, sku: domSku, combo_sku: ''
    };
    return fetch(API.pincodeCheck, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function(r){ return r.json(); })
      .then(function(data){
        var serviceable = !!(data && data.success);
        pincodeResult = {
          pincode: pin,
          serviceable: serviceable,
          city: (data && data.city) || '',
          estimated_delivery_date: (data && data.estimated_delivery_date) || '',
          storename: (data && data.Storename) || '',
          address: (data && data.Address) || ''
        };
        D.setPincode(pin, pincodeResult);
        if (serviceable) {
          // Keep the delivery confirmation, but use the neutral (non-green) status
          // tone — the done-state delivery banner carries the full message.
          setStatus(pinStatus, (pincodeResult.city ? 'Deliverable in ' + pincodeResult.city : 'Serviceable') + (pincodeResult.estimated_delivery_date ? ' by ' + pincodeResult.estimated_delivery_date : ''), 'info');
          logNitro(pin, 'yes', data);
          track('pincode_valid', { pincode: pin, city: pincodeResult.city });
        } else {
          var msg = (data && data.message) ? data.message : 'Delivery not available for this pincode';
          setStatus(pinStatus, msg, 'info');
          logNitro(pin, 'no', data || {});
          track('pincode_invalid', { pincode: pin, reason: msg });
          trackQlp('qlp_invalid_pincode', { pincode: pin, reason: msg });
        }
        return true; // always proceed to OTP so we still capture the lead
      })
      .catch(function(err){
        console.warn('[popup-pp] pincode check failed', err);
        setStatus(pinStatus, 'Could not verify pincode, please try again', 'err');
        track('pincode_error', { pincode: pin, error: String(err) });
        return false;
      });
  }

  function logNitro(pin, serviceable, data){
    var url = API.nitroLog; if (!url) return;
    var ids = D.getNitroIds();
    var body = {
      sku: '', pincode: pin, l1_prod_group: cfg.productGroup || '',
      eta: data.estimated_delivery_date || '', delta: '',
      city: data.city || '', serviceable: serviceable,
      qty: 1, sessionid: '', status: 'ACTIVE',
      phone: D.getPhone() || '', coco_name: '', source: 'Website',
      nitroid: ids.nitroid, roamingid: ids.roamingid,
      brandid: cfg.brandId || 'SH'
    };
    var headers = { 'Content-Type': 'application/json' };
    if (API.nitroAuth) headers['Authorization'] = API.nitroAuth;
    try {
      fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(body) }).catch(function(){});
    } catch(e){}
  }

  // ----- Step 2: Send OTP -----
  function sendOtp(phone){
    phone = String(phone || '').trim();
    if (!/^[6-9]\d{9}$/.test(phone)) { setStatus(phStatus, 'Enter a valid 10-digit mobile number', 'err'); return Promise.resolve(false); }
    // No "Sending OTP…" chatter — just lock the button while the request runs.
    if (verifyBtn) verifyBtn.disabled = true;

    return fetch(API.sendOtp, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ mobileNo: phone })
    })
      .then(function(r){ return r.text().then(function(t){ try { return JSON.parse(t); } catch(e){ return { status: r.ok }; } }); })
      .then(function(data){
        if (!data || data.status === false) { setStatus(phStatus, (data && data.message) || 'Could not send OTP', 'err'); track('otp_send_fail', { phone: phone }); trackQlp('qlp_otp_verification_failed', { stage: 'send', phone: phone, reason: (data && data.message) || 'send_fail' }); return false; }
        // No "OTP sent…" success text — the revealed OTP input is the cue.
        var resend = root.querySelector('.popup-pp__resend');
        if (resend) resend.hidden = false;
        // Reveal the inseparable OTP group (input + Verify OTP) + the resend row;
        // keep phone editable.
        otpSent = true;
        if (otpGroup) otpGroup.hidden = false;
        if (otpWrap) { otpWrap.hidden = false; var oi = otpWrap.querySelector('input'); if (oi) { oi.disabled = false; oi.focus(); } }
        if (otpMeta) otpMeta.hidden = false;
        syncVerifyBtn();
        track('otp_sent', { phone: phone });
        trackQlp('qlp_otp_sent', { phone: phone });
        return true;

      })
      .catch(function(err){ setStatus(phStatus, 'Network error, try again', 'err'); track('otp_send_error', { phone: phone, error: String(err) }); trackQlp('qlp_otp_verification_failed', { stage: 'send', phone: phone, error: String(err) }); return false; })
      .finally(function(){ syncVerifyBtn(); });
  }

  // ----- Step 3: Verify OTP (inline) -----
  // Verifies OTP for the given phone; on success marks phoneVerified and ENABLES
  // the bottom CTA. Does NOT finish the flow — final lead + coupon happen on CTA click.
  function verifyOtp(phone, otp){
    if (!/^\d{4,6}$/.test(String(otp))) { setStatus(otpStatus, 'Enter the OTP sent to your phone', 'err'); return Promise.resolve(false); }
    // No "Verifying…" chatter — the in-flight button-disable is the cue.
    var oi = otpWrap ? otpWrap.querySelector('input') : otpInput;
    if (oi) oi.disabled = true;
    return fetch(API.verifyOtp, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ mobileNo: phone, otp: otp })
    })
      .then(function(r){ return r.json(); })
      .then(function(data){
        if (data && data.success !== false) {
          D.setPhone(phone, { otpVerified: true });
          phoneVerified = true;
          verifiedPhone = phone;
          // No "Verified" status text — micro-confirmation is the red ticks + enabled CTA.
          if (otpStatus) { otpStatus.textContent = ''; otpStatus.className = otpStatus.className.replace(/ popup-pp__status--(ok|err|info)/g, ''); }
          if (otpCheck) otpCheck.hidden = false;
          if (phoneCheck) phoneCheck.hidden = false;
          if (otpWrap) otpWrap.classList.add('is-verified');
          if (phField) { var pw = phField.querySelector('.popup-pp__phone-wrap'); if (pw) pw.classList.add('is-verified'); }
          if (oi) oi.disabled = true;          // lock the OTP once verified
          if (phInput) phInput.readOnly = true; // lock phone until user edits to change
          // SS3: once verified, the Resend OTP affordance is no longer needed —
          // hide the entire OTP meta row (Resend link + inline error status).
          if (resendTickHandle) { clearInterval(resendTickHandle); resendTickHandle = null; }
          if (otpMeta) otpMeta.hidden = true;
          setCtaEnabled(true);
          syncVerifyBtn();

          track('otp_verified', { phone: phone });
          trackQlp('qlp_otp_verified', { phone: phone });
          // Capture the lead at verification time (post_otp). Final CTA validates
          // pincode + reveals coupon.
          if (cfg.submitLeadOnVerify === 'true') submitLead('post_otp');
          return true;
        }
        setStatus(otpStatus, (data && data.message) || 'Invalid OTP', 'err');
        if (oi) oi.disabled = false;
        track('otp_invalid', { phone: phone });
        trackQlp('qlp_otp_verification_failed', { stage: 'verify', phone: phone, reason: (data && data.message) || 'invalid' });
        return false;
      })
      .catch(function(err){ setStatus(otpStatus, 'Network error, try again', 'err'); if (oi) oi.disabled = false; track('otp_verify_error', { error: String(err) }); trackQlp('qlp_otp_verification_failed', { stage: 'verify', error: String(err) }); return false; });
  }


  // mark complete when verify succeeds
  window.addEventListener('sleepyhead:' + (cfg.eventPrefix || 'pp') + '_otp_verified', function(e){
    if (e.detail && e.detail.popup_id === popupId) D.markFormCompleted(popupId);
  });

  // Captured name/email from the success-screen details form. Persisted so a
  // re-fired lead (details_submitted) carries them and maps to the same lead_id.
  var capturedDetails = { name: '', email: '' };

  function submitLead(){
    if (!API.googleLeadCapture && !API.salesforceLeadCapture) return;
    var phone = D.getPhone();

    // Phone is MANDATORY per spec — skip POST entirely if missing.
    if (!phone) { track('lead_skipped_no_phone', {}); return; }
    var pinData = D.getPincodeData() || {};
    var attr = (D.getAttribution && D.getAttribution()) || {};
    var gclid = (D.getGclid && D.getGclid()) || attr.gclid || null;
    var stage = (arguments.length && arguments[0]) || 'post_otp';
    var productTitle = (document.querySelector('[data-product-title]')?.textContent || document.querySelector('.product__title')?.textContent || '').trim();
    var productUrl = location.href.indexOf('/products/') !== -1 ? location.href : '';
    // Use captured name/email when the user submitted the details form;
    // otherwise fall back to the historic defaults.
    var leadName  = (capturedDetails.name  || '').trim() || 'SH_User';
    var leadEmail = (capturedDetails.email || '').trim();
    if (D._debug) console.log('[popup-pp] submitLead stage:', stage, '— capturedDetails:', capturedDetails, '— using name:', leadName, 'email:', leadEmail);
    var payload = {
      name: leadName,
      phone: phone,
      email: leadEmail,

      pincode: D.getPincode() || '',
      city: pinData.city || '',
      channel: 'Website',
      event: 'quick_login',
      brand: 'Sleepyhead',
      product_name: productTitle,
      recommendation1: productUrl,
      recommendation2: '',
      recommendation3: '',
      recommendation4: '',
      timestamp: new Date().toISOString(),
      Page_referrer: location.href,
      Questions_answer_array: '',
      Products_recommendation_array: productUrl,
      User_Agent: navigator.userAgent,
      Store_Name: pinData.storename || '',
      Employee_Code: '',
      Tag: 'new_lead',
      lead_stage: stage,
      lead_id: [D.getSessionId ? D.getSessionId() : '', phone, D.getPincode() || ''].join('|'),
      otp_status: (stage === 'post_otp' || stage === 'details_submitted') ? 'verified' : 'pending',

      Event: 'Quick_Login',
      Name: leadName,
      Phone: phone,
      Email: leadEmail || null,

      Pincode: D.getPincode() || null,
      City: pinData.city || null,
      Channel: null,
      Brand: 'Duroflex',
      Store_Name: pinData.storename || null,
      Preferred_Date: null,
      Time_Slot: null,
      Recommendation1: null,
      Recommendation2: null,
      Recommendation3: null,
      Recommendation4: null,
      Products_Recommendation_Array: null,
      Questions_Answer_Array: null,
      Timestamp: new Date().toISOString(),
      Page_Referrer: location.origin + location.pathname,
      User_Agent: navigator.userAgent,
      UTM_AirBoost: attr.utm_campaign || null,
      UTM_Source_AirBoost: attr.utm_source || null,
      UTM_Medium: attr.utm_medium || null,
      GCL_ID: gclid || null
    };
    var dedupeKey = phone + '|' + (payload.Pincode || '') + '|' + stage;
    if (leadSubmitted[dedupeKey] || leadSubmitInFlight[dedupeKey]) {
      trackQlp('qlp_lead_submit_skipped_duplicate', { stage: stage, phone: phone, pincode: payload.Pincode });
      return;
    }
    leadSubmitInFlight[dedupeKey] = true;
    trackQlp('qlp_lead_submit_attempt', { stage: stage, phone: phone, pincode: payload.Pincode });
    function parseLeadResponse(target, r){
      return r.text().then(function(text){
        var parsed = {};
        try { parsed = text ? JSON.parse(text) : {}; } catch(e) { parsed = { raw: text }; }
        if (!r.ok) throw new Error(target + ' HTTP ' + r.status + ': ' + text);
        if (parsed.status && parsed.status !== 'success') {
          throw new Error(target + ' status ' + parsed.status + (parsed.message ? ': ' + parsed.message : ''));
        }
        return parsed;
      });
    }
    function postLeadTarget(target, url, headers){
      if (!url) return Promise.resolve(null);
      trackQlp('qlp_lead_submit_target_attempt', { stage: stage, target: target, phone: phone, pincode: payload.Pincode });
      return fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(payload), keepalive: true })
        .then(function(r){ return parseLeadResponse(target, r); })
        .then(function(data){
          var oid = (data && (data.opportunityId || data.opportunity_id || data.sfsc)) || null;
          track('lead_submitted_' + target, { opportunity_id: oid });
          trackQlp('qlp_lead_submitted_' + target, { stage: stage, target: target, opportunity_id: oid });
          return data;
        })
        .catch(function(err){
          track('lead_error_' + target, { error: String(err) });
          trackQlp('qlp_lead_submit_failed_' + target, { stage: stage, target: target, error: String(err) });
          throw err;
        });
    }
    try {
      var targetPosts = [
        postLeadTarget('google_sheet', API.googleLeadCapture, { 'Content-Type': 'text/plain' })
      ];
      if (stage === 'post_otp') {
        targetPosts.push(postLeadTarget('salesforce', API.salesforceLeadCapture, { 'Content-Type': 'application/json', 'X-Api-Key': API.salesforceLeadKey }));
      }
      if (stage === 'details_submitted') {
        targetPosts.push(postLeadTarget('salesforce', API.salesforceLeadCapture, { 'Content-Type': 'application/json', 'X-Api-Key': API.salesforceLeadKey }));
      }
      var targetNames = (stage === 'post_otp' || stage === 'details_submitted') ? 'google_sheet,salesforce' : 'google_sheet';

      Promise.allSettled(targetPosts)
        .then(function(results){
          var failures = results.filter(function(r){ return r.status === 'rejected'; });
          if (failures.length) {
            throw new Error(failures.length + ' lead target(s) failed');
          }
          leadSubmitted[dedupeKey] = true;
          track('lead_submitted', { targets: targetNames });
          trackQlp('qlp_lead_submitted', { stage: stage, targets: targetNames });
        })
        .catch(function(err){
          track('lead_error', { error: String(err) });
          trackQlp('qlp_lead_submit_failed', { stage: stage, error: String(err) });
        })
        .finally(function(){ leadSubmitInFlight[dedupeKey] = false; });
    } catch(e){
      leadSubmitInFlight[dedupeKey] = false;
      track('lead_error', { error: String(e) });
      trackQlp('qlp_lead_submit_failed', { stage: stage, error: String(e) });
    }
  }

  function finish(){
    setState('done');
    var coupon = root.querySelector('.popup-pp__coupon');
    if (cfg.couponReveal === 'in_popup' && cfg.couponCode) coupon.hidden = false;
    else if (cfg.couponReveal === 'redirect' && cfg.couponCode) setTimeout(function(){ location.href = '/discount/' + encodeURIComponent(cfg.couponCode); }, 1200);
    // Spec 2: successful submit → 30d dismiss across ALL popups (any popup/nudge).
    // Set immediately on completion; do not wait for user × close. markFormCompleted also persists.
    D.markFormCompleted(popupId);
    D.closeWithRules({
      popupId: popupId,
      persistMode: 'days',
      persistDays: 30,
      requireFormStarted: false,
      requireFormCompleted: false
    });
    if (D.setGlobalDismissed) D.setGlobalDismissed(30);
    track('complete', { pincode: D.getPincode(), phone: D.getPhone(), dismiss_kind: 'days_30' });
  }

  // ----- Single-screen interaction wiring -----

  // Phone input: re-validate the Verify button on each keystroke; editing a
  // verified phone resets verification (phone-only keying).
  phInput.addEventListener('input', function(){
    if (phoneVerified && phInput.value.trim() !== verifiedPhone) {
      // User changed a previously-verified number → reset OTP + CTA gate.
      if (phInput) phInput.readOnly = false;
      resetVerification();
      setStatus(otpStatus, '', 'info');
    }
    syncVerifyBtn();
  });

  // Pincode input: editing pincode must NOT reset OTP verification. Just clear
  // any stale pincode status so the next CTA click re-validates cleanly.
  pinInput.addEventListener('input', function(){
    setStatus(pinStatus, '', 'info');
  });

  // Inline "Verify" button → send OTP for the entered phone.
  if (verifyBtn) {
    verifyBtn.addEventListener('click', function(){
      if (verifyBtn.disabled) return;
      var phone = phInput.value.trim();
      trackQlp('qlp_phone_entered', { phone: phone, valid: /^[6-9]\d{9}$/.test(phone) });
      sendOtp(phone).then(function(ok){ if (ok) startResendCountdown(30); });
    });
  }

  // Inline OTP input → reveal the explicit "Verify OTP" button once the OTP
  // reaches the required length. NO API is called automatically (per spec).
  if (otpInput) {
    otpInput.addEventListener('input', syncVerifyOtpBtn);
  }

  // "Verify OTP" button → the ONLY trigger for the Verify OTP API. Disabled while
  // the request is in flight to prevent duplicate verify calls.
  if (verifyOtpBtn) {
    verifyOtpBtn.addEventListener('click', function(){
      if (verifyOtpBtn.disabled) return;
      var otp = otpInput.value.trim();
      if (!/^\d{4,6}$/.test(otp)) { setStatus(otpStatus, 'Enter the OTP sent to your phone', 'err'); return; }
      verifyOtpBtn.disabled = true; // lock during in-flight verify
      verifyOtp(phInput.value.trim(), otp).then(function(ok){
        // Re-enable for a retry only if verification failed and phone still unverified.
        if (!ok && !phoneVerified) syncVerifyOtpBtn();
      });
    });
  }


  // Fetch My Location → reverse-geocode to a pincode and populate the input ONLY.
  // Does not persist, does not validate, does not auto-submit (per spec).
  if (geoBtn) {
    geoBtn.addEventListener('click', function(){
      if (!navigator.geolocation) { setStatus(pinStatus, 'Location not supported on this device', 'err'); return; }
      var origLabel = geoBtn.querySelector('span') ? geoBtn.querySelector('span').textContent : '';
      geoBtn.disabled = true;
      if (geoBtn.querySelector('span')) geoBtn.querySelector('span').textContent = 'Locating…';
      setStatus(pinStatus, 'Detecting your location…', 'info');
      trackQlp('qlp_fetch_location_clicked', {});
      navigator.geolocation.getCurrentPosition(function(pos){
        var lat = pos.coords.latitude, lng = pos.coords.longitude;
        // Free, key-less reverse geocode → returns Indian postcode.
        fetch('https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=' + lat + '&lon=' + lng)
          .then(function(r){ return r.json(); })
          .then(function(data){
            var pin = data && data.address && data.address.postcode ? String(data.address.postcode).replace(/\D/g, '').slice(0, 6) : '';
            if (/^\d{6}$/.test(pin)) {
              pinInput.value = pin;        // populate input only
              setStatus(pinStatus, 'Pincode filled from your location', 'ok');
              trackQlp('qlp_fetch_location_success', { pincode: pin });
            } else {
              setStatus(pinStatus, 'Could not detect a pincode, please enter it', 'err');
              trackQlp('qlp_fetch_location_failed', { reason: 'no_postcode' });
            }
          })
          .catch(function(err){ setStatus(pinStatus, 'Could not detect a pincode, please enter it', 'err'); trackQlp('qlp_fetch_location_failed', { error: String(err) }); })
          .finally(function(){ geoBtn.disabled = false; if (geoBtn.querySelector('span')) geoBtn.querySelector('span').textContent = origLabel; });
      }, function(err){
        setStatus(pinStatus, 'Location permission denied, please enter pincode', 'err');
        trackQlp('qlp_fetch_location_failed', { reason: 'permission', error: String(err && err.message) });
        geoBtn.disabled = false; if (geoBtn.querySelector('span')) geoBtn.querySelector('span').textContent = origLabel;
      }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 });
    });
  }

  // Bottom CTA = final submit. Only reachable when phoneVerified (CTA was disabled
  // otherwise). Validates pincode on click; on failure keeps OTP verified + CTA
  // available so the user can fix the pincode and retry.
  form.addEventListener('submit', function(e){
    e.preventDefault();
    if (submitInFlight) return;
    if (!phoneVerified) { return; } // gate: should not happen (CTA disabled), defensive
    submitInFlight = true;
    var pin = pinInput.value.trim();
    var phone = phInput.value.trim();
    trackQlp('qlp_pincode_entered', { pincode: pin });
    trackQlp('qlp_confirm_clicked', { pincode: pin, phone: phone });
    cta.disabled = true;
    validatePincode(pin).then(function(pinOk){
      submitInFlight = false;
      if (!pinOk) {
        // Pincode failed/invalid → show error, keep OTP verified + CTA usable for retry.
        trackQlp('qlp_invalid_pincode', { pincode: pin });
        setCtaEnabled(true);
        return;
      }
      // Persist phone (verified) + pincode, fire the final lead, reveal coupon.
      D.setPhone(phone, { otpVerified: true });
      submitLead('post_otp');
      finish();
    });
  });


  // Resend OTP with 30-second cooldown timer. Button is disabled during countdown.
  // Resend lives in the .popup-pp__otp-meta row (a sibling of otpWrap), so query from root.
  var resendBtn = root.querySelector('.popup-pp__resend');
  var resendOrigLabel = resendBtn ? resendBtn.textContent.trim() : 'Resend OTP';
  var resendTickHandle = null;
  function startResendCountdown(seconds){
    if (!resendBtn) return;
    var remaining = parseInt(seconds, 10) || 30;
    resendBtn.disabled = true;
    resendBtn.setAttribute('aria-disabled', 'true');
    resendBtn.textContent = resendOrigLabel + ' (' + remaining + 's)';
    if (resendTickHandle) clearInterval(resendTickHandle);
    resendTickHandle = setInterval(function(){
      remaining -= 1;
      if (remaining <= 0) {
        clearInterval(resendTickHandle);
        resendTickHandle = null;
        resendBtn.disabled = false;
        resendBtn.removeAttribute('aria-disabled');
        resendBtn.textContent = resendOrigLabel;
        return;
      }
      resendBtn.textContent = resendOrigLabel + ' (' + remaining + 's)';
    }, 1000);
  }
  if (resendBtn) {
    resendBtn.addEventListener('click', function(){
      if (resendBtn.disabled) return;
      trackQlp('qlp_otp_resent', { phone: phInput.value });
      sendOtp(phInput.value).then(function(ok){
        if (ok) startResendCountdown(30);
      });
    });
  }

  // Change from done state — reset to form so user can re-enter pincode or phone
  var changeDoneBtn = root.querySelector('[data-action="change-from-done"]');
  if (changeDoneBtn) changeDoneBtn.addEventListener('click', function(){
    // Hide delivery banners and coupon, show CTA again
    root.querySelectorAll('.popup-pp__delivery').forEach(function(el){ el.hidden = true; });
    var coupon = root.querySelector('.popup-pp__coupon');
    if (coupon) coupon.hidden = true;
    successBox.hidden = true;
    cta.hidden = false;
    // Clear OTP value so it's not reused
    if (otpInput) { otpInput.value = ''; otpInput.disabled = false; }
    // Clear status messages
    [pinStatus, phStatus, otpStatus].forEach(function(s){ if (s) { s.textContent = ''; s.className = 'popup-pp__status'; } });
    // Back to form state
    setState('form');
    D.track('popup_change_from_done', { popup_id: popupId, pincode: D.getPincode() });
  });

  // ----- Name + Email capture (final success-screen step) -----
  // Both fields mandatory. On submit: push captured name/email (with all the
  // existing details + same lead_id) to BOTH endpoints, then close the popup.
  var detailsBox    = root.querySelector('[data-role="details"]');
  var nameInput     = root.querySelector('[data-field-name="name"]');
  var emailInput    = root.querySelector('[data-field-name="email"]');
  var detailsStatus = root.querySelector('.popup-pp__status--details');
  var detailsSubmit = root.querySelector('[data-action="submit-details"]');
  if (D._debug) console.log('[popup-pp] details elements found:', { detailsBox: !!detailsBox, nameInput: !!nameInput, emailInput: !!emailInput, detailsStatus: !!detailsStatus, detailsSubmit: !!detailsSubmit });
  function isValidEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || '').trim()); }
  function syncDetailsSubmit(){
    if (!detailsSubmit) return;
    var nameOk  = !!(nameInput && nameInput.value.trim());
    var emailOk = !!(emailInput && isValidEmail(emailInput.value));
    detailsSubmit.disabled = !(nameOk && emailOk);
  }
  if (nameInput)  nameInput.addEventListener('input', syncDetailsSubmit);
  if (emailInput) emailInput.addEventListener('input', syncDetailsSubmit);
  if (detailsSubmit) {
    detailsSubmit.addEventListener('click', function(){
      if (detailsSubmit.disabled) return;
      if (D._debug) console.log('[popup-pp] submit-details clicked — nameInput:', nameInput, 'emailInput:', emailInput, 'nameInput.value:', nameInput?.value, 'emailInput.value:', emailInput?.value);
      var nm = (nameInput && nameInput.value || '').trim();
      var em = (emailInput && emailInput.value || '').trim();
      if (D._debug) console.log('[popup-pp] details submit clicked — name:', nm, 'email:', em);
      if (!nm) { if (detailsStatus) detailsStatus.textContent = 'Please enter your name'; return; }
      if (!isValidEmail(em)) { if (detailsStatus) detailsStatus.textContent = 'Please enter a valid email'; return; }
      if (detailsStatus) detailsStatus.textContent = '';
      // Persist captured details so submitLead carries them under the SAME lead_id
      // (sessionId|phone|pincode), mapping cleanly to the earlier OTP lead.
      capturedDetails.name = nm;
      capturedDetails.email = em;
      if (D._debug) console.log('[popup-pp] capturedDetails set to:', capturedDetails);
      // Lock the form while submitting.
      detailsSubmit.disabled = true;
      if (nameInput) nameInput.readOnly = true;
      if (emailInput) emailInput.readOnly = true;
      trackQlp('qlp_details_submitted', { has_email: !!em });
      // Re-POST to BOTH endpoints with name + email + all prior details.
      submitLead('details_submitted');
      // Mark complete + 30d dismiss, then close the popup entirely (per spec).
      D.markFormCompleted(popupId);
      if (D.setGlobalDismissed) D.setGlobalDismissed(30);
      setTimeout(close, 150);
    });
  }

  // Copy coupon
  var copyBtn = root.querySelector('[data-action="copy-coupon"]');

  if (copyBtn) { copyBtn.dataset.origLabel = copyBtn.textContent; }
  if (copyBtn) copyBtn.addEventListener('click', function(){
    var code = (cfg.couponCode || '').trim();
    if (!code) return;
    try { navigator.clipboard.writeText(code); copyBtn.textContent = 'Copied!'; setTimeout(function(){ copyBtn.textContent = copyBtn.dataset.origLabel || 'Copy code'; }, 1800); } catch(e){}
  });

  // ----- Scope check (mirrors popup-chat logic) -----
  function checkScope(){
    var scope = cfg.scope;
    if (scope === 'all') return !deniedByHandle();
    var tpl = cfg.currentTemplate;
    var inc = {
      index: cfg.showHome === 'true', product: cfg.showProduct === 'true', collection: cfg.showCollection === 'true',
      cart: cfg.showCart === 'true', blog: cfg.showBlog === 'true', article: cfg.showBlog === 'true',
      search: cfg.showSearch === 'true'
    };
    var matches = !!inc[tpl];
    if (!(tpl in inc) && cfg.showOther === 'true') matches = true;
    // handle overrides
    var include = D.parseList(cfg.includeHandles);
    var exclude = D.parseList(cfg.excludeHandles);
    if (include.length && include.indexOf(cfg.currentHandle) !== -1) matches = true;
    var ok = (scope === 'include') ? matches : (scope === 'exclude' ? !matches : true);
    if (ok && exclude.length && exclude.indexOf(cfg.currentHandle) !== -1) ok = false;
    return ok;
  }
  function deniedByHandle(){
    var exclude = D.parseList(cfg.excludeHandles);
    return exclude.length && exclude.indexOf(cfg.currentHandle) !== -1;
  }

  }
  function initChip(chip){
    var sectionId = chip.id.replace(/^popup-pp-chip-/, '');
if(!window.SleepyheadPopup)return;var D = window.SleepyheadPopup;
  var textEl = chip.querySelector('.popup-pp-chip__text');
  var changeBtn = chip.querySelector('[data-action="reopen-popup"]');
  var template = chip.dataset.textTemplate || 'Deliver to [pincode]';
  var chipWasShown = false;
  var initialRestoreFired = false;

  function render(){
    var pin = D.getPincode();
    if (!pin) {
      chip.hidden = true;
      chipWasShown = false;
      return;
    }
    var data = D.getPincodeData() || {};
    var txt = template
      .replace(/[\[\{]pincode[\]\}]/g, pin)
      .replace(/[\[\{]city[\]\}]/g,    data.city || '')
      .replace(/[\[\{]eta[\]\}]/g,     data.estimated_delivery_date || '');
    textEl.textContent = txt;
    chip.hidden = false;
    // qlp_delivery_widget_shown: fire once per render transition into visible.
    if (!chipWasShown) {
      chipWasShown = true;
      D.track('qlp_delivery_widget_shown', { pincode: pin, city: data.city || '' });
      // qlp_delivery_state_restored: pincode already stored from a prior session
      // (loaded from localStorage on initial chip render).
      if (!initialRestoreFired) {
        initialRestoreFired = true;
        D.track('qlp_delivery_state_restored', { pincode: pin, city: data.city || '', eta: data.estimated_delivery_date || '' });
      }
    }
  }

  if (changeBtn) {
    changeBtn.addEventListener('click', function(){
      // Force-open bypasses dismiss + skip-if-pincode-set gates
      window.dispatchEvent(new CustomEvent('sleepyhead:open-pincode-popup', { detail: { force: true } }));
      D.track('pincode_chip_change_clicked', { pincode: D.getPincode() });
      D.track('qlp_delivery_change_clicked', { pincode: D.getPincode() });
    });
  }

  // Bound-gate: mark chip as fully wired AFTER the click listener binds. CSS
  // hides the chip until this attribute flips to "true", preventing any
  // race where the chip appears clickable but JS hasn't attached yet.
  chip.setAttribute('data-pp-chip-bound', 'true');

  // Show initially if pincode already stored
  render();
  // Update when pincode changes from any popup
  window.addEventListener('sleepyhead:pincode_set', render);
  // Hide when explicitly cleared
  window.addEventListener('storage', function(e){
    if (e.key === D._keys.pincode) render();
  });

  }
  function bootAll(){
    document.querySelectorAll('.popup-pp').forEach(initPopup);
    document.querySelectorAll('.popup-pp-chip').forEach(initChip);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();

document.addEventListener('click', function(e){
  const btn = e.target.closest('.popup-pp__copy-code-btn');
  if(!btn) return;

  const code = btn.dataset.couponCode;

  navigator.clipboard.writeText(code);

  const span = btn.querySelector('span');
  const original = span.textContent;

  span.textContent = 'Copied!';

  setTimeout(() => {
    span.textContent = original;
  }, 2000);
});
